import { awaitTo } from "@/utils";

export default {
  methods: {
    awaitTo
  }
};
